import { proxy } from '@/utils'

export const _inputFilter = value => {
  return value?.join('\n')
}
export const _outputFilter = value => {
  return value?.split(/[\n,]+/)?.map(item => {
    return item.trim()
  })?.filter(Boolean)
}

export const core = {
  mixins: [ proxy({ type: 'array' }) ],

  props: {
    required: Boolean
  },

  methods: {
    _inputFilter,
    _outputFilter
  }
}
